<template>
  <div class="body-div">
    <div class='page_row pb20 pt20' ref="pageRow" @click='toSearch'>
      <div class="search">
        <div class="df search_arr">
          <div class="iconfont icon-fangdajing searchcion f32 pl10" type='search'></div>
          <input placeholder="请输入关键字" type="text" class="search-input"/>
        </div>
      </div>
    </div>
    <div class="flex-center" v-show="!isHidden">
      <div class='view-shade'>{{viewNum}}</div>
    </div>
    <div class="h30"></div>
    <!-- <div hover-class="bcE3" wx:for='{{list}}'>
      <div class="h90 lh90 ml40 mr40 f32 border-bottom">
         {{item.cataIndex}}.{{item.name}}
      </div>
    </div> -->
    <div class="flex-wrap">
      <div class="flex-left scroll" :style="{'height':scrollHeight}" >
        <div v-for="(item,index) in categoryList">
          <div class="cate-top">
            {{item.categoryName}}
          </div>
          <div v-for="(c,index) in item.childList"  hover-class="bcEE"
               class="h90 lh90 text-center f28 border-bottom " :class="[categoryId==c.id?'c24af08':'']"
               :data-id="c.id" @click="chooseCate">
            {{c.categoryName}}
          </div>
        </div>
      </div>
      <div class="flex-right scroll" :style="{height:scrollHeight}" :scroll-into-div="toView" >
        <div v-for="(item,index) in list" hover-class="bcEE" :id="['view'+item.cataIndex]"
             @click="toSongPage" :data-type="item.type" :data-index="item.cataIndex">
          <div class="h90 lh90 ml40 mr30 f28 border-bottom" :class="[categoryId==item.categoryId?'c3d852e':'']">
            {{item.cataIndex}}.{{item.name}}
          </div>
        </div>
      </div>
      <div class="zimulist" ref="zimuList" @touchmove="touchmovefn" @touchstart="touchstartfn"
           @touchend="hideToast">
        <div class="zimu f28" v-for="(item,index) in indexList" :data-id="item">
          {{item}}
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import http from '@/util/http.js'
import '@/css/cata.css'

  export default {
  name: 'cata',
  data () {
    return {
      isHidden:true,
      num:"",
      list:[],
      indexList: [],
      categoryList:[],
      scrollIntoId:'',
      listHeight:'',
      listTop:'',
      length:'',
      toView:'',
      viewNum:0,
      scrollHeight:0,
      isHidden: true,
      categoryId:null
    }
  },
  mounted(){
    /*wx.showLoading({
      title: '加载中...',
    })
    */
    this.getCategoryList();
    this.getContentList();
    this.scrollHeight =  (document.documentElement.clientHeight - this.$refs.pageRow.offsetHeight - 70)+'px'
    this.listHeight =  this.$refs.zimuList.offsetHeight;
    this.listTop =  this.$refs.zimuList.offsetTop;
  },
  methods: {
    getCategoryList () {
      let that = this;
      http.post('/song/getCategoryList',null).then(res => {
        if (res.code === 0) {
          that.categoryList = res.data
        }
      })
    },
    getContentList(){
      let that = this;
      http.post('/song/getContentsList', null).then(res => {
        if (res.code === 0) {
          const list = res.data;
          that.list = list;
          if (list.length > 0) {
            const num = Math.round(list.length / 100);
            const indexList = [];
            for (let i = 0; i <= num; i++) {
              indexList.push(i)
            }
            that.indexList = indexList;
            that.length = list.length;
          }
        }
        //wx.hideLoading();
      })
    },
    showPanel(){
      this.isHidden = false
    },
    hidePanel () {
      this.isHidden = true
    },
    inputNum(e){
      const number = this.num + e.currentTarget.dataset.num;
      this.num = number
    },
    touchmovefn (e) { // 右侧字母检索
      let letterIndex = e.changedTouches[0].clientY - this.listTop + 2;
      let num = Math.round((letterIndex / this.listHeight) * this.length);
      if (num < 1) {
        num = 1;
      } else if (num > this.length) {
        num = this.length;
      }
      if (num) {
        document.getElementById('view'+num).scrollIntoView();
        this.viewNum = num;
        this.showToast();
      }
    },
    touchstartfn (e) {
      let letterIndex = e.changedTouches[0].clientY-this.listTop+2
      let num = Math.round((letterIndex / this.listHeight) * this.length);

      if(num<1){
        num = 1;
      } else if (num > this.length){
        num = this.length;
      }
      //console.log(e.target.id)
      if (num){
        document.getElementById('view'+num).scrollIntoView();
        this.viewNum = num;
        this.showToast();
      }
    },
    showToast(){
      this.isHidden = false
    },
    hideToast(){
      let that = this;
      setTimeout(function () {
        that.isHidden = true;
      }, 1000)
    },
    toSearch(){
      this.$router.push({
        name: 'search'
      })
    },
    toSongPage(e){
      this.$router.push({
        name: 'songPage',
        query:{
          number:e.currentTarget.dataset.index,
          type:e.currentTarget.dataset.type
        }
      })
    },
    chooseCate(e){
      let cateId = e.currentTarget.dataset.id;
      let that = this;
      let list = this.list;
      for(let c in list){
        if (list[c].categoryId == cateId){
          that.categoryId = cateId;
          document.getElementById('view'+list[c].cataIndex).scrollIntoView();
          return;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cata.vue